module.exports = __webpack_public_path__ + "img/pantalla-4-6.63c733d2.png";